/* KICX polish layer JS v3 (11 Jun 2026) — magnetic CTAs, card tilt, staggered reveals,
   Label X-ray, scroll progress, image fade-in. Custom cursor removed at Hudson's request.
   Purely additive: the site renders and functions identically if this file never loads. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var kicx = document.querySelectorAll('.kicx-home, .kicx-page');

  /* ── Magnetic CTAs: buttons pull gently toward the cursor (max ~6px) ── */
  if (fine && !reduced) {
    var clamp = function (v, m) { return Math.max(-m, Math.min(m, v)); };
    document.querySelectorAll('.kicx-home .btn, .kicx-page .btn, .kicx-home .add-btn, .kicx-page .add-btn, .kicx-home .dark-btn, .kicx-page .dark-btn, .kicx-home .ghost-btn, .kicx-page .ghost-btn').forEach(function (btn) {
      var pressed = false;
      var apply = function (e) {
        var r = btn.getBoundingClientRect();
        var dx = clamp((e.clientX - (r.left + r.width / 2)) * 0.18, 6);
        var dy = clamp((e.clientY - (r.top + r.height / 2)) * 0.3, 5) - 2;
        btn.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)' + (pressed ? ' scale(.96)' : '');
      };
      btn.addEventListener('pointermove', function (e) { if (!e.pointerType || e.pointerType === 'mouse') apply(e); }, { passive: true });
      btn.addEventListener('pointerdown', function (e) { pressed = true; if (e.pointerType === 'mouse') apply(e); });
      btn.addEventListener('pointerup', function (e) { pressed = false; if (e.pointerType === 'mouse') apply(e); });
      btn.addEventListener('pointerleave', function () { pressed = false; btn.style.transform = ''; });
    });
  }

  /* ── Card 3D tilt: subtle, follows cursor, resets on leave ── */
  if (fine && !reduced) {
    document.querySelectorAll('.kicx-home .pcard, .kicx-page .pcard').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) translateY(-8px) rotateX(' + (-py * 4).toFixed(2) + 'deg) rotateY(' + (px * 4).toFixed(2) + 'deg)';
        card.style.setProperty('--kx-mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--kx-my', (e.clientY - r.top) + 'px');
      }, { passive: true });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
    /* spotlight tracking for non-tilting cards */
    document.querySelectorAll('.kicx-home .tcard, .kicx-page .rcard').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--kx-mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--kx-my', (e.clientY - r.top) + 'px');
      }, { passive: true });
    });
  }

  /* ── Reveal stagger + post-reveal delay cleanup (so hovers are never delayed) ── */
  if (kicx.length && !reduced) {
    var grids = '.shop-grid,.testi-grid,.rev-grid,.why-grid,.standards-grid,.war-grid,.ing-list,.certs .wrap,.stats .wrap';
    kicx.forEach(function (root) {
      root.querySelectorAll(grids).forEach(function (grid) {
        var i = 0;
        Array.prototype.forEach.call(grid.children, function (el) {
          if (!el.classList || !el.classList.contains('reveal')) return;
          if (/\bd[123]\b/.test(el.className) || el.style.transitionDelay) return;
          el.style.transitionDelay = Math.min(i * 80, 480) + 'ms';
          i++;
        });
      });
    });
    document.querySelectorAll('.kicx-home .reveal, .kicx-page .reveal').forEach(function (el) {
      var hasDelay = /\bd[123]\b/.test(el.className) || el.style.transitionDelay;
      if (!hasDelay) return;
      var clear = function () { setTimeout(function () { el.style.transitionDelay = '0s'; }, 1300); };
      if (el.classList.contains('visible')) { clear(); return; }
      var mo = new MutationObserver(function () {
        if (el.classList.contains('visible')) { clear(); mo.disconnect(); }
      });
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ── "True to Label" X-ray: hovering/tapping an ingredient scans the photo with its dose ── */
  (function () {
    var photo = document.querySelector('.kicx-home .ing-photo');
    var cards = document.querySelectorAll('.kicx-home .ing-card');
    if (!photo || !cards.length) return;
    photo.classList.add('kx-xray');
    var chip = document.createElement('div'); chip.className = 'kx-xray-chip';
    chip.innerHTML = '<b></b><span></span>';
    var scan = document.createElement('div'); scan.className = 'kx-xray-scan';
    photo.appendChild(scan); photo.appendChild(chip);
    var hideT;
    cards.forEach(function (card, i) {
      var name = card.querySelector('h4'), dose = card.querySelector('.ing-dose');
      if (!name || !dose) return;
      var show = function (rescan) {
        clearTimeout(hideT);
        chip.querySelector('b').textContent = name.textContent;
        chip.querySelector('span').textContent = dose.textContent + ' · exactly as labelled';
        chip.style.setProperty('--kx-chip-y', (18 + i * 24) + '%');
        if (rescan && photo.classList.contains('kx-xray-on')) {
          scan.style.animation = 'none'; void scan.offsetHeight; scan.style.animation = '';
        }
        photo.classList.add('kx-xray-on');
      };
      var hide = function () { hideT = setTimeout(function () { photo.classList.remove('kx-xray-on'); }, 400); };
      card.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') show(true); });
      card.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hide(); });
      card.addEventListener('click', function () {
        if (card.classList.contains('open')) { show(true); } else { hide(); }
      });
    });
  })();

  /* ── Scroll progress bar on product + article pages ── */
  if (/template-product|template-article/.test(document.body.className)) {
    var bar = document.createElement('div'); bar.id = 'kx-progress';
    document.body.appendChild(bar);
    var upd = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(window.scrollY / max, 1) : 0) + ')';
    };
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
  }

  /* ── Image fade-in: only images still loading get the fade, 3s failsafe ── */
  if (kicx.length && !reduced) {
    document.querySelectorAll('.kicx-home img, .kicx-page img').forEach(function (img) {
      if (img.complete) return;
      img.classList.add('kx-imgwait');
      var show = function () { img.classList.add('kx-imgin'); };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
    });
    setTimeout(function () {
      document.querySelectorAll('.kx-imgwait:not(.kx-imgin)').forEach(function (img) { img.classList.add('kx-imgin'); });
    }, 3000);
  }
})();
